"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Center = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _CenterComponent = require("./component/CenterComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "className", "width", "height", "bg", "borderRadius", "boxShadow", "borderWidth", "borderStyle", "borderColor", "margin", "padding"];
const Center = props => {
  const {
      children,
      className,
      width = '100%',
      height = '100%',
      bg = 'none',
      borderRadius = '0px',
      boxShadow,
      borderWidth,
      borderStyle,
      borderColor,
      margin,
      padding
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const centerComponentStyle = ['center-style', className].join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CenterComponent.CenterComponent, Object.assign({
    width: width,
    height: height,
    bg: bg,
    borderRadius: borderRadius,
    className: centerComponentStyle,
    boxShadow: boxShadow,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderColor: borderColor,
    margin: margin,
    padding: padding
  }, rest, {
    children: children
  }));
};
exports.Center = Center;
var _default = exports.default = Center;